import React from "react";
import { useStore } from "store/storeUtils";
import { observer } from "mobx-react";
import { Snackbar } from "@tecma/ds/snackbar";

const SnackbarError = observer(() => {
  const store = useStore();

  return (
    <Snackbar
      open={store.snackbarError}
      handleClose={() => store.setSnackbarError(false)}
      hideDuration={5000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      title={store.snackbarMessage || ""}
      type='error'
    />
  );
});

export default SnackbarError;
